import { BaseTable } from '@/components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { useAlarmsTable } from '@/hooks/AssetsStudioPage/MainContent/Alarms/useAlarmsTable';

interface AlertsTableProps {
  tableData: any;
}

export function AlarmsTable({ tableData }: AlertsTableProps) {
  const eventDates = useMemo(() => {
    if (!tableData || tableData.length === 0) return [];
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Matches "yyyy-MM-dd"
    return Object.keys(tableData?.[0]).filter((key) => dateRegex.test(key));
  }, [tableData]);
  const { group_by, metric } = useSelector((state: RootState) => state.alarms);
  const { tableStructure } = useAlarmsTable({ additionalHeaders: eventDates, dataType: metric });

  return (
    <BaseTable
      stickyFirstColumn={false}
      enableSearch={true}
      defaultSortId="total"
      // pageSize={100}
      variant="dense"
      classNames={{
        card: {
          container: 'h-full w-full bg-gray-200 flex flex-col overflow-hidden',
          content: 'h-full flex-1 overflow-hidden',
        },
        table: {
          container: `
              h-full w-full overflow-auto
            `,
          th: `
          first-of-type:z-40
              bg-gray-200 sticky top-0 z-30 px-4
              [&>*]:flex [&>*]:w-full [&>*]:text-subtext [&>*]:font-medium 
              [&>*]:text-left [&>*]:justify-start [&>*]:h-14 [&>*]:w-min
            `,
          td: `
              p-0 [&>*]:h-14 [&>*]:flex [&>*]:items-center [&>*]:justify-center 
              first-of-type:w-min !w-min last-of-type:!w-full
            `,
          tr: 'hover:cursor-default',
          table: 'w-full',
        },
      }}
      data={tableData}
      columns={tableStructure}
    />
  );
}
